import signedFetch from '../util/signedFetch.js';

export default (orgId, courseId = null) => {
  let url = `${__API_BASE__}/ngs/org/${orgId}/marks`;
  if (courseId) url += `?courseIds=${courseId}`;

  return signedFetch('ngsGetHomework', url);
};
